import { render } from "./FooterPart.vue?vue&type=template&id=cebe5f54&scoped=true"
import script from "./FooterPart.vue?vue&type=script&lang=js"
export * from "./FooterPart.vue?vue&type=script&lang=js"

import "./FooterPart.vue?vue&type=style&index=0&id=cebe5f54&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebe5f54"]])

export default __exports__